/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:13/06/2021
 @Time:11:55
 //le code js partagé entre tous les pages backend et frontend
 **/

import "jquery-ui";
require ('expose-loader?exposes=moment!moment');
import "../vendors/3rd/bootstraps";
import "bootstrap5-multi-level-dropdown/js/bootstrap5-multi-level-dropdown-browser";
import Begro from "./Begro";
import "../i18n/module_web";
window.Begro=Begro;
import "./form";
import "../vendors/begro/ajax";
import "../vendors/begro/begro-toggle"
import '../vendors/3rd/form_elements/form_elements';
import "../vendors/3rd/underscore";
import PerfectScrollbar from "perfect-scrollbar"
window.PerfectScrollbar=PerfectScrollbar;
import "../vendors/3rd/icons";
require ('expose-loader?exposes=ProgressBar!progressbar.js');
require ('expose-loader?exposes=AOS!aos/dist/aos');
import "jquery-slimscroll/jquery.slimscroll";
import "../vendors/3rd/countdown";
import "flipclock/dist/flipclock";
import "jquery-knob/dist/jquery.knob.min";
import "../vendors/3rd/horizontal-timeline";
import "jquery-nestable/jquery.nestable";
import "jquery-raty-js/lib/jquery.raty";
import "webticker/jquery.webticker";
import "expose-loader?exposes=screenfull!screenfull"
//import "../vendors/3rd/fullcalendar";
//import "./mindmup-editabletable";//url https://github.com/mindmup/editable-table/blob/master/mindmup-editabletable.js todo essayer de remplacer cette librairie
//import "eve/eve"; //todo si non nécessaire on le supprime
//import "gridstack/dist/gridstack";//todo vérifier son utilisation
//import "prismjs/prism"; = vérifier son utilisation
